<template>
  <aside>
    <h1>Aurora creator</h1>
    <div class="ctrl-wrap">
      <Picker title="Color" prop="color" />
      <Picker title="Background" prop="bgColor" />
      <Checkbox title="Transparency" prop="transparency" />
      <Range
        title="Brightness"
        prop="brightness"
        min="0.1"
        max="5.0"
        step="0.01"
        minlabel="Dark"
        maxlabel="Bright"
      />
      <Range
        title="Density"
        prop="frequency"
        min="0"
        max="2"
        step="0.01"
        minlabel="Broad"
        maxlabel="Packed"
      />
      <Range
        title="Zoom"
        prop="amplitude"
        min="0"
        max="2"
        step="0.01"
        minlabel="Close"
        maxlabel="Far"
      />
      <Range
        title="Speed"
        prop="velocity"
        min="1"
        max="50"
        step="0.01"
        minlabel="Fast"
        maxlabel="Slow"
      />
      <Checkbox title="Round Corner" prop="rounded" />
    </div>
  </aside>
</template>

<script>
import Picker from "../ui/Picker";
import Checkbox from "../ui/Checkbox";
import Range from "../ui/Range";

export default {
  name: "Aside",
  components: {
    Picker,
    Checkbox,
    Range,
  },
};
</script>

<style scoped>
aside {
  display: flex;
  flex-direction: column;
  min-width: 25vw;
  background: #142531;
  color: #fff;
  border-color: #fff;
  height: fit-content;
  padding: 3rem;
  min-height: 100vh;
}
h1 {
  margin-bottom: 6rem;
}
.ctrl-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.ctrl-wrap > * {
  margin-bottom: 2rem;
}
</style>